import {
  StylesProvider,
  createGenerateClassName,
} from '@material-ui/core/styles'

import { AppShell } from './app-shell'

const generateClassName = createGenerateClassName({
  productionPrefix: 'minimal-app-shell',
})

export function Root() {
  return (
    <StylesProvider generateClassName={generateClassName}>
      <AppShell />
    </StylesProvider>
  )
}
